class Tabs {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._tabNav = this._elem.querySelector('[data-tabs-header]')
        this._tabContent = this._elem.querySelector('[data-tabs-content]')
        this._tabContentAreas = this._tabContent.querySelectorAll('[data-tab]')
        this._tabNavAnchors = this._tabNav.querySelectorAll('[data-tabs-anchor]')
        this._event = new Event('tab-changed')
        this._event.tabs = {
            activeHandle: this._tabNavAnchors[0].dataset.tabsAnchor,
            activeTab: this._tabNavAnchors[0]
        }
        this._attr = {
            activeHandle: this._tabNavAnchors[0].dataset.tabsAnchor,
            activeTab: this._tabNavAnchors[0]
        }
    }

    onInit () {
        let isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style

        for (let tabAnchor of this._tabNavAnchors) {
            tabAnchor.addEventListener('click', (e) => {
                e.preventDefault()
                let parentLi = tabAnchor.parentNode
                let tabIndex = parentLi.dataset.tabLinked
                this._attr.activeHandle = tabAnchor.dataset.tabsAnchor
                this._attr.activeTab = tabAnchor
                this._event.tabs.activeHandle = tabAnchor.dataset.tabsAnchor
                this._event.tabs.activeTab = tabAnchor

                for (let otherTabAnchor of this._tabNavAnchors) {
                    otherTabAnchor.parentNode.classList.remove('active')
                }

                parentLi.classList.add('active')

                if (isSmoothScrollSupported) {
                    this._tabNav.scroll({
                        top: 0,
                        left: parentLi.offsetLeft,
                        behavior: 'smooth'
                    })
                } else {
                    this._tabNav.scrollLeft = parentLi.offsetLeft
                }

                document.dispatchEvent(this._event)

                for (let tabContentArea of this._tabContentAreas) {
                    tabContentArea.classList.remove('active')
                }

                this._tabContent.querySelector(`[data-tab='${tabIndex}']`).classList.add('active')
            })
        }
    }
}

export default Tabs



// WEBPACK FOOTER //
// ./src/scripts/components/Tabs.js